<template>
  <div class="broken" :class="{ 'full-height': broken }">
    <template v-if="broken">
      <div class="broken-link">
        <div class="logo">
          <img src="@/assets/logo-small-white.png" />
        </div>
        <div class="broken-text">
          <svg style="width:100px;height:84px" viewBox="-2 2 28 18">
            <path fill="#ccc"
              d="M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.43 19.12,14.63 17.79,15L19.25,16.44C20.88,15.61 22,13.95 22,12A5,5 0 0,0 17,7M16,11H13.81L15.81,13H16V11M2,4.27L5.11,7.38C3.29,8.12 2,9.91 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12C3.9,10.41 5.11,9.1 6.66,8.93L8.73,11H8V13H10.73L13,15.27V17H14.73L18.74,21L20,19.74L3.27,3L2,4.27Z" />
          </svg>
          <span class="link">
            Link is broken or does not exist
          </span>
        </div>
      </div>
    </template>
    <template v-if="!broken">

      <template v-if="extname === '.pdf'">
        <div class="view-file pdf" v-if="seen" @contextmenu="notallowed">
          <div class="img">
            <iframe :src=path width="100%" height="100%"></iframe>
          </div>
        </div>
      </template>

      <template v-if="extname === '.txt'">
        <div class="view-file" v-if="seen" @contextmenu="notallowed">
          <div class="header">
            <div class="left">
              <span>
                <svg style="width:24px;height:24px" viewBox="0 0 24 24" @click="close_box" class="close">
                  <path fill="#fff" d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
                </svg>
              </span>
              <span>
                {{ name }}
              </span>
            </div>
            <div class="right">
              <span @click="print">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#fff"
                    d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z" />
                </svg>
              </span>
              <span @click="download">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#fff" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
                </svg>
              </span>
            </div>
          </div>
          <div class="txt">
            <div class="txt-content">

            </div>
          </div>
          <div class="footer">
            <div class="floor">
              <span @click="zoomin">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#fff" d="M19,13H5V11H19V13Z" />
                </svg>
              </span>
              <span @click="reset">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#fff"
                    d="M15.5,14H14.71L14.43,13.73C15.41,12.59 16,11.11 16,9.5A6.5,6.5 0 0,0 9.5,3A6.5,6.5 0 0,0 3,9.5A6.5,6.5 0 0,0 9.5,16C11.11,16 12.59,15.41 13.73,14.43L14,14.71V15.5L19,20.5L20.5,19L15.5,14M9.5,14C7,14 5,12 5,9.5C5,7 7,5 9.5,5C12,5 14,7 14,9.5C14,12 12,14 9.5,14M7,9H12V10H7V9Z" />
                </svg>
              </span>
              <span @click="zoomout">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#fff" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </template>

      <template v-if="extname === 'image'">
        <div class="view-file" v-if="seen" @click="close_box" @contextmenu="notallowed">
          <div class="header">
            <div class="left">
              <span @click="close_box">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24" @click="close_box" class="close">
                  <path fill="#fff" d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
                </svg>
              </span>
              <span>
                {{ name }}
              </span>
            </div>
            <div class="right">
              <span @click="print">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#fff"
                    d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z" />
                </svg>
              </span>
              <span @click="download">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#fff" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
                </svg>
              </span>
              <!--<span>
                              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                                  <path fill="#fff" d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
                              </svg>
                          </span>-->
            </div>
          </div>
          <div class="img">
            <img ref="img" :src="path" />
          </div>
          <div class="footer">
            <div class="floor">
              <span @click="zoomin">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#fff" d="M19,13H5V11H19V13Z" />
                </svg>
              </span>
              <span @click="reset">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#fff"
                    d="M15.5,14H14.71L14.43,13.73C15.41,12.59 16,11.11 16,9.5A6.5,6.5 0 0,0 9.5,3A6.5,6.5 0 0,0 3,9.5A6.5,6.5 0 0,0 9.5,16C11.11,16 12.59,15.41 13.73,14.43L14,14.71V15.5L19,20.5L20.5,19L15.5,14M9.5,14C7,14 5,12 5,9.5C5,7 7,5 9.5,5C12,5 14,7 14,9.5C14,12 12,14 9.5,14M7,9H12V10H7V9Z" />
                </svg>
              </span>
              <span @click="zoomout">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#fff" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </template>

      <template v-if="extname === 'video'">
        <div class="play-video" v-if="seen">
          <div class="video-loader" v-if="!play">
            <span>
              <svg width="120px" height="120px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid" class="lds-dual-ring"
                style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;">
                <circle cx="50" cy="50" fill="none" stroke-linecap="round" r="20" stroke-width="4" stroke="#039aed"
                  stroke-dasharray="31.41592653589793 31.41592653589793">
                  <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
                    keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite" />
                </circle>
              </svg>
            </span>
            <span>Loading file....</span>
          </div>
          <div class="player" v-if="play">
            <div class="controls">
              <span>
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#888888" d="M19,13H5V11H19V13Z" />
                </svg>
              </span>
              <span>
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#888888" d="M4,4H20V20H4V4M6,8V18H18V8H6Z" />
                </svg>
              </span>
              <span class="close" @click="close_box">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#888888"
                    d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                </svg>
              </span>
            </div>
            <vue-plyr>
              <video controls class="img-fluid">
                <source :src="src" :type="format" />
              </video>
            </vue-plyr>
          </div>
        </div>
      </template>

      <template v-if="extname === 'audio'">
        <div class="play-video" v-if="seen" @click="close_box" @keyup="esc_close">
          <div class="video-loader" v-if="!play">
            <span>
              <svg width="120px" height="120px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid" class="lds-dual-ring"
                style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;">
                <circle cx="50" cy="50" fill="none" stroke-linecap="round" r="20" stroke-width="4" stroke="#039aed"
                  stroke-dasharray="31.41592653589793 31.41592653589793">
                  <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
                    keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite" />
                </circle>
              </svg>
            </span>
            <br />
            <span>Loading file....</span>
          </div>
          <div class="player" v-if="play">
            <vue-plyr>
              <audio controls>
                <source :src="src" :type="format" />
              </audio>
            </vue-plyr>
          </div>
        </div>
      </template>

    </template>
    <template v-if="download_process">
      <p class="d-flex justify-center items-center">File downloaded</p>
    </template>
    <loading ref="loading"></loading>
  </div>
</template>
<style scoped>
.view-file .img {
  display: flex;
  justify-content: center;
}

.full-height {
  display: flex;
  justify-content: center;
  align-items: center;
}

.broken {
  height: 100%;
}

.broken-link {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.broken-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}
</style>
<script>
import loading from '../components/Loading'
import config from '@/services/config'
import { viewfile } from '@/services/Api'
import cookies from "@/services/cookies";

export default {
  components: {
    loading
  },
  data() {
    return {
      broken: false,
      name: '',
      extname: '',
      download_url: process.env.VUE_APP_NODE_ENV === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT : process.env.VUE_APP_HTTP + '://' + config.origin,
      seen: false,
      file_id: '',
      path: '',
      src: '',
      format: '',
      download_process: false
    }
  },
  methods: {
    str_text(str) {
      return str.length > 38 ? str.substr(0, 38) + '...' : str
    },
    print() {
      window.open('/print-text/' + this.file_id)
    },
    download() {
      let id = this.file_id
      let a = document.createElement('a')
      a.setAttribute('download', true)
      a.setAttribute('href', this.download_url + '/download-file?id=' + id)
      a.hidden = true
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    zoomin() {
      let div = document.querySelector('.txt .txt-content')

      if (this.text_point > 0) {
        this.text_size = this.text_size - 2
        div.style.fontSize = this.text_size + 'px'
        this.text_point -= 1
      }
    },
    reset() {
      let div = document.querySelector('.txt .txt-content')
      div.style.fontSize = 16 + 'px'
      this.text_size = 16
    },
    zoomout() {
      let div = document.querySelector('.txt .txt-content')

      if (this.text_point < 5 && this.text_size !== 26) {
        this.text_size = this.text_size + 2
        div.style.fontSize = this.text_size + 'px'
        this.text_point += 1
      }
    },
    notallowed(e) {
      e.preventDefault();
    },
    close_box(evt) {
      if (evt.target.className === 'view-file' || evt.target.className.baseVal === 'close') {
        let data = {
          fileid: this.id
        }

        this.$socket.emit('deleteblock', data)
        this.seen = false
      }
    }
  },
  mounted() {
    let data = {
      link: location.href
    }

    let that = this
    this.seen = true
    this.$refs.loading.load()

    viewfile(data).then(res => {
      if (res.data.extname === '.pdf') {
        that.$refs.loading.close()
        that.extname = res.data.extname
        that.seen = true
        that.file_id = res.data.id
        that.path = process.env.VUE_APP_NODE_ENV === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/pdf/' + res.data.id : process.env.VUE_APP_HTTP + '://' + config.origin + '/pdf/' + res.data.id
      }

      if (res.data.extname === '.txt') {
        that.name = res.data.name
        that.extname = res.data.extname
        setTimeout(function () {
          let div = document.querySelector('.txt .txt-content')
          that.$refs.loading.close()
          that.seen = true
          that.file_id = res.data.id
          div.innerText = res.data.content
        }, 5000)
      }

      if (res.data.type === 'image') {
        that.$refs.loading.close()
        that.extname = 'image'
        that.path = process.env.VUE_APP_NODE_ENV === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/loadimage/' + res.data.id : process.env.VUE_APP_HTTP + '://' + config.origin + '/loadimage/' + res.data.id
        that.seen = true
        that.file_id = res.data.id
        setTimeout(function () {
          that.default_height = that.$refs.img.height
          that.default_width = that.$refs.img.width
        }, 1000)
      }

      if (res.data.type === 'video') {
        console.log('uieie')
        that.$refs.loading.close()
        that.extname = 'video'

        that.seen = true;
        that.src = "";
        that.play = false;
        let id = res.data.id;

        let data = {
          token: cookies.getCookie("token"),
          id: id,
        };

        const src = `${process.env.VUE_APP_FILE_WATCHER_SERVER}/files/${id}`;
        that.src = src;
        that.format = data.format;
        setTimeout(function () {
          that.play = true;
        }, 2000);

        // that.path = process.env.VUE_APP_NODE_ENV === 'development' ? process.env.VUE_APP_HTTP + '://' + config.origin + ':' + process.env.VUE_APP_PORT + '/loadimage/' + res.data.id : process.env.VUE_APP_HTTP + '://' + config.origin + '/loadimage/' + res.data.id
        // that.seen = true
        // that.file_id = res.data.id
        // setTimeout(function () {
        //   that.default_height = that.$refs.img.height
        //   that.default_width = that.$refs.img.width
        // }, 1000)
      }

      if (res.data.type === 'audio') {
        that.extname = 'audio'
        that.seen = true;
        that.src = "";
        that.play = false;
        let id = res.data.id

        let data = {
          token: cookies.getCookie("token"),
          id: id,
        };

        const src = `${process.env.VUE_APP_FILE_WATCHER_SERVER}/files/${id}`;
        that.format = data.format;
        setTimeout(function () {
          that.play = true;
        }, 2000);
      }

      /*
      if ((res.data.type !== 'image' || res.data.type !== 'video' || res.data.type !== 'audio') && (res.data.extname !== '.txt' || res.data.extname === '.pdf')) {
        that.download_process = true
        that.$refs.loading.close()
        let token = cookies.getCookie("token");

        let id = res.data.id
        let a = document.createElement("a");
        a.setAttribute("download", true);
        let href =
          process.env.VUE_APP_NODE_ENV !== "development"
            ? process.env.VUE_APP_HTTP +
            "://" +
            config.origin +
            "/download?id=" +
            id +
            "&token=" +
            token
            : process.env.VUE_APP_HTTP +
            "://" +
            config.origin +
            ":" +
            process.env.VUE_APP_PORT +
            "/download?id=" +
            id +
            "&token=" +
            token;
        a.setAttribute("href", href);
        a.hidden = true;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }*/

      that.broken = false
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>
